import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getQueryStringFromParams } from "../utils/paramUtils";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { LinkableTaxPayerDto } from "./LinkableTaxPayerDto";

interface FetchLinkableTaxPayersParams {
    levyId?: string;
    year?: number;
}

export function useGetLinkableTaxPayers(params?: FetchLinkableTaxPayersParams) {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();

    const query = useQuery<LinkableTaxPayerDto[]>({
        queryKey: ["useGetLinkableTaxPayers", workspaceId, params],
        queryFn: async () => {
            const queryString =
                params?.levyId || params?.year
                    ? getQueryStringFromParams({
                          ...(params.levyId ? { levyId: params.levyId } : {}),
                          ...(params.year ? { year: params.year } : {}),
                      })
                    : "";
            const url = `${BASE_API_URL}/tenants/${workspaceId}/linkable-tax-payers?${queryString}`;
            const response = await fetch(url, { headers });

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        initialData: [],
        meta: {
            resourceName: t("errors.resourceName.linkableTaxPayers"),
        },
    });

    return query;
}
